import { MessagePlugin } from 'tdesign-vue-next'
import { useRuntimeConfig } from '#imports'

export async function copyToClipboard(text: string): Promise<void> {
  await navigator.clipboard.writeText(text)
  MessagePlugin.success('复制成功')
}

export function joinFileUrl(url = '') {
  if (url.startsWith('http') || !url) {
    return url
  }
  const env = useRuntimeConfig()
  return env.public.ossProxyTarget + '/' + url
}
